/* tslint:disable */
/* eslint-disable */
import React from 'react';
import { Box, Typography, Chip } from '@material-ui/core';
import { useCommonStyles } from './AdminConsoleBilling';
import { DateTime } from 'luxon';
import { Warning } from '@material-ui/icons';

type Props = {
  upcoming: any;
  invoices: any[];
};

export const BillingOverview = (props: Props) => {
  const classes = useCommonStyles();
  const { upcoming, invoices } = props;

  // Find unpaid invoices
  const unpaidInvoices = invoices.filter((invoice) => invoice.status === 'open' || invoice.status === 'past_due');

  // Get the most recent unpaid invoice or use upcoming
  const currentUnpaidInvoice = unpaidInvoices.length > 0 ? unpaidInvoices[0] : null;
  const hasOverduePayment = unpaidInvoices.length > 0;

  // Use current unpaid invoice date if exists, otherwise upcoming
  const nextDueDate =
    currentUnpaidInvoice && currentUnpaidInvoice.due_date
      ? DateTime.fromJSDate(new Date(currentUnpaidInvoice.due_date * 1000))
      : upcoming?.next_payment_attempt
      ? DateTime.fromJSDate(new Date(upcoming.next_payment_attempt * 1000))
      : DateTime.local();

  const amountDue = currentUnpaidInvoice ? currentUnpaidInvoice.amount_due : upcoming?.amount_due || 0;

  const hasPaymentIssue = hasOverduePayment || upcoming?.status === 'open' || upcoming?.status === 'past_due';

  return (
    <Box>
      <Typography className={classes.sectionHeading}>Overview</Typography>
      <Box mt={2}>
        <Box mb={3}>
          <Typography className={classes.overviewItemHeading}>
            {hasOverduePayment ? 'Payment Overdue' : 'Next Due Date'}
          </Typography>
          <Typography className={classes.overviewItemData} style={{ color: hasOverduePayment ? '#d32f2f' : undefined }}>
            {nextDueDate.toFormat('LLL dd, yyyy')}
          </Typography>
          {hasPaymentIssue && (
            <Box mt={1}>
              <Chip
                icon={<Warning style={{ fontSize: '16px', color: hasOverduePayment ? '#d32f2f' : '#856404' }} />}
                label={hasOverduePayment ? 'Update Payment Details' : 'Payment Required'}
                size='small'
                style={{
                  backgroundColor: hasOverduePayment ? '#ffebee' : '#fff3cd',
                  color: hasOverduePayment ? '#d32f2f' : '#856404',
                  fontSize: '12px',
                  fontWeight: 600,
                  paddingLeft: '7px',
                  paddingRight: '7px',
                }}
              />
            </Box>
          )}
          {unpaidInvoices.length > 1 && (
            <Box mt={1}>
              <Typography style={{ fontSize: '12px', color: '#d32f2f', fontWeight: 500 }}>
                {unpaidInvoices.length} unpaid invoices
              </Typography>
            </Box>
          )}
        </Box>
        <Box>
          <Typography className={classes.overviewItemHeading}>
            {hasOverduePayment ? 'Amount Overdue' : 'Next Invoice Estimate'}
          </Typography>
          <Typography className={classes.overviewItemData} style={{ color: hasOverduePayment ? '#d32f2f' : undefined }}>
            ${(amountDue / 100).toFixed(2)}
          </Typography>
          {hasOverduePayment && (
            <Typography style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
              Please update your payment method to avoid service interruption
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};
